import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { useIntl } from 'react-intl';

import { getTabUrlParam, updateTabUrlParam } from '../../helpers';
import { userIsAdmin } from '../../helpers/Auth';

import AdminBackUrl from '../../components/Admin/BackUrl';
import PageDetailsTabs from '../../components/Admin/Pages/Details/PageDetailsTabs';
import PageDetailsTabContent from '../../components/Admin/Pages/Details/PageDetailsTabContent';

const PageDetails = ({ match }) => {
  const intl = useIntl();

  const [activeTab, setActiveTab] = useState(getTabUrlParam() || 'collected-details');

  const handleSwitchTab = (tab) => {
    setActiveTab(tab);
    updateTabUrlParam(tab);
  };

  if (!userIsAdmin()) {
    return null;
  }

  return (
    <div className="main-content">
      <Container fluid>
        <AdminBackUrl urls={[{ url: '/admin/pages', label: intl.formatMessage({ defaultMessage: 'Content Portals' }) }]} />
        <header className="page-header">
          <h2 className="page-title">
            <i className="far fa-circle-info" />
            {intl.formatMessage({ defaultMessage: 'Content Portal details' })}
          </h2>
        </header>
        <div className="content-wrapper">
          <PageDetailsTabs
            handleSwitchTab={handleSwitchTab}
            activeTab={activeTab}
          />
          <PageDetailsTabContent
            pageId={match.params.pageId}
            activeTab={activeTab}
          />
        </div>
      </Container>
    </div>
  );
};

PageDetails.propTypes = {
  match: PropTypes.object.isRequired,
};

export default PageDetails;
